import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { deleteCartStorage } from '@/redux/slices/storage.slice';
import { useAppDispatch } from '@/redux';
import { NS } from '@/constants';
import { getAttributeValue, getProductImage } from '@/utils/productUtils';
import { getStorageWineboxContent, setCartStorageItems } from '@/utils/storageUtils';
import SelectDropdown from '@/components/common/SelectDropdown';
import ProductImage from '@/components/product/ProductImage';

import styles from './CheckoutCartStorageProduct.module.scss';
import { ATTRIBUTES } from '@/constants/product';

export const CheckoutCartStorageProduct = ({ product, readOnly }) => {
  const { t } = useTranslation(NS.CELLAR);

  const dispatch = useAppDispatch();
  const { image, isWineBox, productName, quantity, shortDesc, storageProducts } = product;

  const productDesc = useMemo(() => {
    const attributes = [
      getAttributeValue(storageProducts[0].storageProductForCart, ATTRIBUTES.APPELLATION, ''),
      getAttributeValue(storageProducts[0].storageProductForCart, ATTRIBUTES.COLOR, '')
    ].filter(Boolean).join(' - ');

    return (
      <div>{attributes}</div>
    );
  }, [storageProducts]);

  const getWineBoxDesc = () => (
    <div dangerouslySetInnerHTML={{ __html: getStorageWineboxContent(storageProducts[0]) }} />
  );

  const getSelectorOptions = useMemo(() => {
    const options = [];
    for (let i = 0; i <= quantity; i++) {
      options.push({ label: i, value: i });
    }
    return options;
  }, [quantity]);
  const handleChangeQuantity = (qte) => {
    const cartStorageItems = setCartStorageItems(product, qte, true);
    dispatch(deleteCartStorage({ cartStorageItems }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <ProductImage
          url={getProductImage(image, isWineBox, 'mobile')}
          alt={productName}
          size="mobile"
        />
      </div>
      <div className={styles.content}>
        <div className={styles.name}>{(!productName && isWineBox) ? t('cartStorage.wineBox') : productName}</div>
        {isWineBox ? (
          getWineBoxDesc()
        ) : (
          productDesc
        )}
        <div className={styles.description}>{shortDesc}</div>
      </div>
      <div className={styles.selector}>
        {!readOnly ?
          <SelectDropdown
            selected={{ value: quantity, label: quantity }}
            options={getSelectorOptions}
            onChange={handleChangeQuantity}
          /> :
          <div className={styles['read-only']} data-test-id="read-only">{t('labels.quantity')} {quantity}</div>
        }
      </div>
      <div className={styles.text}>
        {t('checkout:cart.storage')}
      </div>
    </div>
  );
};
export default CheckoutCartStorageProduct;
